import { memo } from 'react';

const PrintableArea = ({ printImage, printPoints, config, configCode, wiring = [], wiringImage }) => {
    const getHandleLabel = (nodeId, handleId) => {
        if (nodeId && nodeId.startsWith('junction')) {
            const num = nodeId.split('-')[1];
            return `Splice ${num}`;
        }
        return handleId || 'Unknown';
    };

    return (
        <div id="printable-area">
            {/* PAGE 1 */}
            <div className="print-page-1">
                <div className="print-image-container">
                    {printImage && <img src={printImage} alt="unit" />}

                    {Object.keys(printPoints).map(id => id.startsWith('Q') && config[id] && (
                        <div key={id} className="print-label" style={{
                            position: 'absolute',
                            left: printPoints[id].left,
                            top: printPoints[id].top,
                            transform: 'translate(-50%, -50%)',
                            background: 'rgb(255, 215, 0)',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            border: '1.5px solid rgb(0, 40, 70)',
                            fontSize: '11px',
                            fontWeight: 900,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            {id}: {config[id].name}
                        </div>
                    ))}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'rgb(0, 40, 70)', fontWeight: 900, margin: '0', fontSize: '32px' }}>SPECIFICATION</h1>
                        <div style={{ color: '#64748b', fontSize: '14px', marginBottom: '40px', fontWeight: 700 }}>CODE: {configCode}</div>

                        <h3 style={{ borderBottom: '3px solid rgb(0, 40, 70)', paddingBottom: '10px', color: 'rgb(0, 40, 70)' }}>INTERNAL HARDWARE</h3>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '15px', marginBottom: '30px' }}>
                            {config.inner_components.length > 0 ? config.inner_components.map((item, i) => (
                                <span key={i} style={{ padding: '6px 12px', fontSize: '15px', background: '#f1f5f9', borderRadius: '6px', fontWeight: 600, color: 'rgb(0, 40, 70)' }}>
                                    • {item.name}
                                </span>
                            )) : (
                                <span style={{ fontSize: '15px', color: '#94a3b8' }}>No options selected</span>
                            )}
                        </div>

                        <h3 style={{ borderBottom: '3px solid rgb(0, 40, 70)', paddingBottom: '10px', color: 'rgb(0, 40, 70)' }}>PIN CONNECTIONS</h3>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '10px 40px',
                            marginTop: '15px'
                        }}>
                            {wiring.length > 0 ? wiring.map((edge, idx) => (
                                <div key={edge.id} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    borderBottom: '1px solid #f1f5f9',
                                    paddingBottom: '5px',
                                    fontWeight: 700
                                }}>
                                    <span style={{ color: '#64748b' }}>
                                        {getHandleLabel(edge.source, edge.sourceHandle)} → {getHandleLabel(edge.target, edge.targetHandle)}
                                    </span>
                                </div>
                            )) : (
                                <div style={{ color: '#94a3b8', fontSize: '14px' }}>No connections defined</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* PAGE 2 */}
            {wiringImage && (
                <div className="print-page-2">
                    <h2 style={{ color: '#002846', borderBottom: '2px solid #002846', paddingBottom: '10px', marginBottom: '20px' }}>
                        Wiring Diagram
                    </h2>
                    <img
                        src={wiringImage}
                        alt="Wiring Diagram"
                        style={{
                            width: '100%',
                            maxHeight: '85vh',
                            objectFit: 'contain',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            background: '#334155'
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default memo(PrintableArea);